'use client';

import * as DS from '@aurorasolar/ds';

import { ButtonLink } from '@/app/lp/components';
import { TRACKING } from '@/helpers/tracking';

type Props = {
  /** Post pathname when rendered from server content, where usePathname is not the post URL */
  page?: string;
};

// Entry CTA for the bill-shock posts. It REPLACES the generic post-footer CTA
// there (brief: do not coexist — two CTAs create choice paralysis and muddy
// the resonance measurement).
export const BillProjectionEntryCta = ({ page }: Props) => (
  <DS.Flex bg="uiBgAlternate">
    <DS.Flex
      alignItems={{ md: 'center' }}
      flexDirection={{ _: 'column', md: 'row' }}
      gap={6}
      justifyContent="space-between"
      maxW={DS.BorealisTheme.screens.xl}
      mx="auto"
      px={{ _: 6, lg: 10 }}
      py={{ _: 8, lg: 10 }}
      textAlign="left"
    >
      <DS.Flex flex={1} gap={2} minW={0}>
        <DS.Text as="h2" text="h1">
          Is your bill just going to keep going up?
        </DS.Text>
        <DS.Text color="uiHelperCopy" text="body16">
          Project your electricity costs over the next 20 years — with and without solar. Takes about 30 seconds, and
          you don’t share any contact information.
        </DS.Text>
      </DS.Flex>
      {/* DS.Flex defaults w=100%; without an md override this wrapper + flexShrink={0}
          swallows the row and collapses the copy column to zero width */}
      <DS.Flex alignItems={{ md: 'center' }} flexShrink={0} w={{ _: '100%', md: 'auto' }}>
        <ButtonLink
          event={{ data: { placement: 'bill-projection-entry', ...(page && { page }) }, name: TRACKING.BLOG_CTA_CLICK }}
          icon={DS.IconArrowRight}
          iconPosition="right"
          path="/home-solar/bill-projection"
          variant="cta"
        >
          Project my bill
        </ButtonLink>
      </DS.Flex>
    </DS.Flex>
  </DS.Flex>
);
